const check = {

	init: function() {

		$('.voorwaardenAkkoordCheckbox').click(function() {
			var verder = true;
			$('.voorwaardenAkkoordCheckbox').each(function() {
				if (!this.checked) {
					verder = false;
				}
			});
			if (verder) {
				$('#voorwaardenAkkoord').attr('disabled', false);
			} else {
				$('#voorwaardenAkkoord').attr('disabled', true);
			}
		});

	}

};

export default check;
